import * as React from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { postRequest } from '../../../../lib/api';
import { AuthContext } from '../../../../authContext/context';
import { useContext, useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import BreadcrumbsWrapper from '../../../../components/breadcrumbs';

export default function CreateTasks() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    reset
  } = useForm({
    defaultValues: {
      product: '',
      name: '',
      details: '',
      applyTargetType: 'userGroup',
      targetUserGroup: '',
      targetUser: '',
      deleteOnStatusChange: false,
      completionDueNum: '',
      completionDueUnit: 'hours'
    }
  });

  // Dropdown data states
  const [products, setProducts] = useState([]);
  const [userGroups, setUserGroups] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  
  // Watch applyTargetType to conditionally render target fields
  const applyTargetType = watch('applyTargetType');


  // Fetch products
  const fetchProducts = async () => {
    try {
      const response = await postRequest('private/getproductList', {}, authCtx.token);
      if (response?.status === 200 && response?.data) {
        setProducts(response.data);
      }
    } catch (err) {
      console.error('Error fetching products:', err);
    }
  };

  // Fetch user groups
  const fetchUserGroups = async () => {
    try {
      const response = await postRequest('private/userGroupList', { page: 1, limit: 100 }, authCtx.token);
      if (response?.status === 200 && response?.data?.docs) {
        setUserGroups(response.data.docs);
      }
    } catch (err) {
      console.error('Error fetching user groups:', err);
    }
  };

  // Fetch users (usertype = 1) from auths model
  const fetchUsers = async () => {
    try {
      const response = await postRequest('private/UserList', {
        page: 1, 
        limit: 100,
        username: '',  // Required to avoid regex error
        email: '',     // Required to avoid regex error
        name: ''       // Required to avoid regex error
      }, authCtx.token);
      
      console.log('User list response:', response);
      
      if (response?.status === 200 && response?.data?.docs) {
        // The backend already filters for userType.type = 1
        // We just need to set the users that have forename and surname
        const usersWithNames = response.data.docs.filter(user => 
          user.forename || user.surname
        );
        console.log('Users from auths model with type 1:', usersWithNames);
        setUsers(usersWithNames);
      } else if (response?.status === 200 && response?.data && Array.isArray(response.data)) {
        // If data is directly an array
        const usersWithNames = response.data.filter(user => 
          user.forename || user.surname
        );
        console.log('Users from auths model (direct array):', usersWithNames);
        setUsers(usersWithNames);
      }
    } catch (err) {
      console.error('Error fetching users from auths model:', err);
    }
  };

  // On initial load
  useEffect(() => {
    fetchProducts();
    fetchUserGroups();
    fetchUsers();
    // eslint-disable-next-line
  }, []);

  // Handle form submission with react-hook-form
  const onSubmit = async (data) => {
    try {
      setLoading(true);
      
      // Prepare payload
      const payload = {
        product_id: data.product,
        name: data.name,
        details: data.details,
        apply_target_type: data.applyTargetType,
        target_user_group: data.applyTargetType === 'userGroup' ? data.targetUserGroup : null,
        target_user: data.applyTargetType === 'user' ? data.targetUser : null,
        delete_on_status_change: data.deleteOnStatusChange,
        completion_due_num: data.completionDueNum,
        completion_due_unit: data.completionDueUnit
      };

      console.log('Saving task definition:', payload);

      // API call to save task definition
      const response = await postRequest('private/createTaskDefinition', payload, authCtx.token);
      
      if (response?.status === 200 || response?.status === 'success') {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Task Definition created successfully!'
        }).then(() => {
navigate('/system-setup/taskdefinitions ');
        });
      } else {
        Swal.fire('Error', response?.message || 'Failed to create task definition', 'error');
      }
    } catch (error) {
      console.error('Error creating task definition:', error);
      Swal.fire('Error', 'Something went wrong. Please try again.', 'error');
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <BreadcrumbsWrapper
        items={[
          { label: 'Dashboard', path: '/dashboard' },
          { label: 'Task Definitions', path: '/system-setup/task-definitions' },
          { label: 'Create Task Definition', path: '' },
        ]}
      />
      <br></br>
      <div className='page-header pb-3'>
        <h1 className='mt-0 mb-0'>Create Task Definition</h1>
       
      </div>

      {/* Search Form */}
      <div className='page-top-formview mb-3'>
        <div style={{ 
          backgroundColor: '#fff', 
          borderRadius: '8px', 
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          padding: '24px'
        }}>
         <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-3">
             <Col xs={6}>
               <Form.Group as={Col} controlId="searchId">
              
               <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" error={!!errors.product}>
                                <InputLabel id="product-select-label">Product</InputLabel>
        <Controller
          name="product"
          control={control}
          rules={{ required: 'Product is required' }}
          render={({ field }) => (
            <Select
              {...field}
              labelId="product-select-label"
              id="product-select"
              label="Product"
            >
              <MenuItem value="">Select Product</MenuItem>
              {products.map((product) => (
                <MenuItem key={product._id} value={product._id}>
                  {product.title}
                </MenuItem>
              ))}
            </Select>
          )}
        />
        {errors.product && (
          <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
            {errors.product.message}
          </Form.Control.Feedback>
        )}
                                </FormControl>
            </Form.Group>
             </Col>
             <Col xs={6}>
             <Form.Group as={Col} controlId="searchId">
              
               <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" >
<TextField 
  id="name-field" 
  label="Name" 
  variant="outlined" 
  {...register('name', { required: 'Name is required' })}
  error={!!errors.name}
  helperText={errors.name?.message}
/>
               </FormControl>
               </Form.Group>
             
             </Col>
            
          
            </Row>
            <Row className="mb-4">
            <Form.Group as={Col} controlId="searchId">
              <h5>Task Details</h5>
               <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" >
                             

                             <TextareaAutosize
  aria-label="minimum height"
  minRows={3}
  placeholder="Enter task details here..."
  {...register('details')}
  style={{ 
    width: '100%',
    padding: '12px',
    fontSize: '14px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontFamily: 'inherit'
  }}
/>
                                </FormControl>

            </Form.Group>
            </Row>


            <Row className="mb-3">
                <h5 style={{ marginBottom: '16px' }}>Apply Target</h5>
                
                {/* Radio buttons for target type */}
                <Col xs={12}>
                  <FormControl component="fieldset" sx={{ mb: 2 }}>
                    <Controller
                      name="applyTargetType"
                      control={control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          row
                        >
                          <FormControlLabel value="userGroup" control={<Radio />} label="User Group" />
                          <FormControlLabel value="user" control={<Radio />} label="User" />
                        </RadioGroup>
                      )}
                    />
                  </FormControl>
                </Col>
                
             <Col xs={12}>
               <Form.Group as={Col} controlId="searchId">
              
               <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" error={!!errors.targetUserGroup || !!errors.targetUser}>
                 {applyTargetType === 'userGroup' ? (
                   <>
                     <InputLabel id="user-group-select-label">User Group</InputLabel>
                     <Controller
                       name="targetUserGroup"
                       control={control}
                       rules={{ 
                         required: applyTargetType === 'userGroup' ? 'User Group is required' : false 
                       }}
                       render={({ field }) => (
                         <Select
                           {...field}
                           labelId="user-group-select-label"
                           id="user-group-select"
                           label="User Group"
                         >
                           <MenuItem value="">Select User Group</MenuItem>
                           {userGroups.map((group) => (
                             <MenuItem key={group._id} value={group._id}>
                               {group.title}
                             </MenuItem>
                           ))}
                         </Select>
                       )}
                     />
                     {errors.targetUserGroup && (
                       <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                         {errors.targetUserGroup.message}
                       </Form.Control.Feedback>
                     )}
                   </>
                 ) : (
                   <>
                     <InputLabel id="user-select-label">User</InputLabel>
                     <Controller
                       name="targetUser"
                       control={control}
                       rules={{ 
                         required: applyTargetType === 'user' ? 'User is required' : false 
                       }}
                       render={({ field }) => (
                         <Select
                           {...field}
                           labelId="user-select-label"
                           id="user-select"
                           label="User"
                         >
                           <MenuItem value="">Select User</MenuItem>
                           {users.length > 0 ? users.map((user) => (
                             <MenuItem key={user._id} value={user._id}>
                               {user.forename || ''} {user.surname || ''}
                             </MenuItem>
                           )) : <MenuItem value="" disabled>No users found</MenuItem>}
                         </Select>
                       )}
                     />
                     {errors.targetUser && (
                       <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
                         {errors.targetUser.message}
                       </Form.Control.Feedback>
                     )}
                   </>
                 )}
               </FormControl>
            </Form.Group>
             </Col>
            <Form.Group className='mt-3'>
          
  <Controller
    name="deleteOnStatusChange"
    control={control}
    render={({ field }) => (
      <FormControlLabel 
        control={
          <Checkbox  
            {...field}
            checked={field.value}
            sx={{
              color: '#0009',
              '&.Mui-checked': {
                color: '#bb0000',
              },
            }}
          />
        } 
        label="Delete on Status Change" 
      />
    )}
  />
            </Form.Group>
          
            </Row>
             <hr style={{ margin: '24px 0' }} />
             
             <Row className="mb-3">
                <h5 style={{ marginBottom: '16px' }}>Completion Due</h5>
             <Col xs={6}>
               <Form.Group as={Col} controlId="searchId">
              
               <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" >
                        <TextField 
                          id="completion-due-num" 
                          type="number" 
                          label="Num" 
                          variant="outlined" 
                          {...register('completionDueNum', { 
                            min: { value: 1, message: 'Number must be at least 1' } 
                          })}
                          error={!!errors.completionDueNum}
                          helperText={errors.completionDueNum?.message}
                        />
                                </FormControl>
            </Form.Group>
             </Col>
             <Col xs={6}>
            <Form.Group as={Col} controlId="searchId">
              
               <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" >
                                <InputLabel id="time-unit-select-label">Time Unit</InputLabel>
        <Controller
          name="completionDueUnit"
          control={control}
          render={({ field }) => (
            <Select
              {...field}
              labelId="time-unit-select-label"
              id="time-unit-select"
              label="Time Unit"
            >
              <MenuItem value="hours">Hours</MenuItem>
              <MenuItem value="days">Days</MenuItem>
              <MenuItem value="weeks">Weeks</MenuItem>
              <MenuItem value="months">Months</MenuItem>
            </Select>
          )}
        />
                                </FormControl>
            </Form.Group>
             
             </Col>
        
          
            </Row>
        
            <Row>
           
            <Form.Group as={Col} controlId="searchId">
              
               <FormControl sx={{ my: 1, width: '100%' }} variant="outlined" >
                                <Stack spacing={2} direction="row">
                                    <Button 
                                      variant="outlined" 
                                      className='red-outline-btn text-capitalize'
                                      onClick={() => navigate('/system-setup/taskdefinitions')}
                                    >
                                      Cancel
                                    </Button>
                                    <Button 
                                      variant="contained" 
                                      type="submit" 
                                      className='red-bg red-button text-capitalize h-56'
                                    >
                                      Save Task Definition
                                    </Button>

                            </Stack>
                                </FormControl>
            </Form.Group>


          </Row>
        </Form> 
        </div>


      </div>

      {/* Table View */}
      <div>
        

      </div>
    </>
  );
}
